const BLOCK_TAGS = new Set([
  'P', 'DIV', 'LI', 'UL', 'OL', 'TR', 'TD', 'TH',
  'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'BLOCKQUOTE', 'SECTION', 'ARTICLE',
]);

function isSafeHref(href) {
  if (!href || typeof href !== 'string') return false;
  const trimmed = href.trim();
  if (!trimmed || /^javascript:/i.test(trimmed) || /^data:/i.test(trimmed)) return false;
  try {
    const u = new URL(trimmed, 'https://example.invalid');
    const scheme = u.protocol.toLowerCase();
    return scheme === 'http:' || scheme === 'https:' || scheme === 'mailto:';
  } catch {
    return false;
  }
}

function normalizeHref(href) {
  const trimmed = (href || '').trim();
  if (!trimmed) return '';
  if (/^www\./i.test(trimmed)) return `https://${trimmed}`;
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  return trimmed;
}

function extractNodeText(node) {
  if (!node) return '';
  if (node.nodeType === Node.TEXT_NODE) return node.textContent || '';
  if (node.nodeType !== Node.ELEMENT_NODE) return '';

  const tag = node.tagName;
  if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'META' || tag === 'HEAD') return '';

  if (tag === 'A') {
    const rawHref = node.getAttribute('href') || '';
    const href = normalizeHref(rawHref);
    const label = extractChildrenText(node).replace(/\s+/g, ' ').trim();
    if (href && isSafeHref(href)) {
      if (!label || label === href || label === rawHref.trim()) return href;
      return `[${label}](${href})`;
    }
    return label;
  }

  if (tag === 'BR') return '\n';

  let out = '';
  for (const child of node.childNodes) {
    out += extractNodeText(child);
  }

  if (BLOCK_TAGS.has(tag) && out && !out.endsWith('\n')) {
    out += '\n';
  }
  return out;
}

function extractChildrenText(node) {
  let out = '';
  for (const child of node.childNodes) {
    out += extractNodeText(child);
  }
  return out;
}

/** Преобразует HTML из буфера обмена в plain text с markdown-ссылками [текст](url). */
export function clipboardHtmlToPlainTextWithLinks(html) {
  if (!html || typeof html !== 'string') return '';
  if (typeof DOMParser === 'undefined') return '';

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const body = doc?.body;
  if (!body) return '';

  return extractNodeText(body)
    .replace(/\r\n/g, '\n')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trimEnd();
}

export function insertTextIntoTextarea(textarea, insertText, currentValue, onValueChange) {
  if (!textarea || insertText == null) return;
  const value = currentValue ?? '';
  const start = textarea.selectionStart ?? value.length;
  const end = textarea.selectionEnd ?? value.length;
  const next = value.slice(0, start) + insertText + value.slice(end);
  onValueChange(next);
  const caret = start + insertText.length;
  requestAnimationFrame(() => {
    try {
      textarea.focus();
      textarea.setSelectionRange(caret, caret);
    } catch {
      /* ignore */
    }
  });
}
